import { type AxiosResponse } from 'axios';

import { CreateOtpType, ReadVerifyOtpType, type LoginAdminType } from '@/types';

import { axiosGet, axiosPost } from '@/api/AxiosApi';
import { sendRequest } from '@/api/AxiosRequest';
import { type CustomAxiosResponse } from '@/api/AxiosResponse';

export const readAdminCode = async ({ code }: { code: string }): Promise<CustomAxiosResponse | AxiosResponse> => {
  const payload = {
    path: '/admin-codes/code',
    body: { code },
  };
  return sendRequest(payload, 'readAdminCode', axiosPost);
};

// 아이디 중복 체크
export const readAdminId = async (id: string) => {
  const payload = {
    path: `/admin-login/${id}`,
  };
  return sendRequest(payload, 'readAdminId', axiosGet);
};
// 관리자 로그인
export const loginAdmin = async (aData: LoginAdminType) => {
  const payload = {
    path: '/admin-login/login',
    body: { ...aData },
  };
  return sendRequest(payload, 'readAdminList', axiosPost);
};

// otp 로그인
export const otpLogin = async (createOtpType: CreateOtpType) => {
  const payload = {
    path: '/admin-login/create-otp',
    body: { ...createOtpType },
  };
  return sendRequest(payload, 'otpLogin', axiosPost);
};
// otp 인증
export const verifyOtp = async (readVerifyOtpType: ReadVerifyOtpType) => {
  const payload = {
    path: '/admin-login/verify-otp',
    body: { ...readVerifyOtpType },
  };
  return sendRequest(payload, 'verifyOtp', axiosPost);
};

// otp 활성화
export const enableOtp = async (id: string) => {
  const payload = {
    path: `/admin-login/enable-otp`,
    body: { id },
  };
  return sendRequest(payload, 'enableOtp', axiosPost);
};
